export default __webpack_public_path__ + "c1932842eb36ed8201c1cf948337510b.svg";